export const VARIANT = "variant";
export const GENE = "gene";
export const DISEASE = "disease";
export const DRUG = "drug";
export const CHEMICAL = "chemical";
// export const CELL_TYPE = "cell_type";
export const CELL_LINE = "cell_line";
export const ORGAN = "organ";
export const ANAT = "tissue-organ";
export const ORGANISM = "organism";
export const FUNCTIONAL = "functional";
export const INH_MODE = "inheritance_mode";
export const CLIN_SIG = "clinical_significance";
export const IMPACT = "coding_impact";

export const SEPERATOR = ":";

export const TAG_SORT = {
  [VARIANT]: 1,
  [GENE]: 2,
  [DISEASE]: 3,
  [DRUG]: 4,
  [CHEMICAL]: 5,
  [ANAT]: 6,
  [CELL_LINE]: 7,
  [ORGANISM]: 8,
  [FUNCTIONAL]: 9,
  [INH_MODE]: 10,
  [CLIN_SIG]: 11,
  [IMPACT]: 12,
};

export const TAG_COLOR = {
  [VARIANT]: "tw-text-blue-500",
  [GENE]: "tw-text-purple-500",
  [DISEASE]: "tw-text-orange-500",
  [DRUG]: "tw-text-indigo-500",
  [CHEMICAL]: "tw-text-green-500",
  [ANAT]: "tw-text-pink-500",
  [CELL_LINE]: "tw-text-red-500",
  [ORGANISM]: "tw-text-amber-500",
  [FUNCTIONAL]: "tw-text-teal-500",
  [CLIN_SIG]: "tw-text-yellow-500",
  [INH_MODE]: "tw-text-cyan-500",
  [IMPACT]: "tw-text-green-500",
};

export const TAG_BG = {
  [VARIANT]: "tw-bg-blue-500",
  [GENE]: "tw-bg-purple-500",
  [DISEASE]: "tw-bg-orange-500",
  [DRUG]: "tw-bg-indigo-500",
  [CHEMICAL]: "tw-bg-green-500",
  [ANAT]: "tw-bg-pink-500",
  [CELL_LINE]: "tw-bg-red-500",
  [ORGANISM]: "tw-bg-amber-500",
  [FUNCTIONAL]: "tw-bg-teal-500",
  [CLIN_SIG]: "tw-bg-yellow-500",
  [INH_MODE]: "tw-bg-cyan-500",
  [IMPACT]: "tw-bg-green-500",
};

export const TAG_TITLES = {
  [GENE]: "Gene",
  [VARIANT]: "Variant",
  [DISEASE]: "Disease / Phenotype",
  [DRUG]: "Drug",
  [CHEMICAL]: "Chemical Compound",
  [ANAT]: "Organ / Tissue",
  [CELL_LINE]: "Cell Line",
  [ORGANISM]: "Organism / Group",
  [FUNCTIONAL]: "Functional Study",
  [CLIN_SIG]: "Clinical Significance",
  [INH_MODE]: "Inheritance Mode",
  [IMPACT]: "Coding Impact",
};
